/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import OldVersionScreen from 'components/Utils/OldVersionScreen';
import HTML5 from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'antd/dist/antd.min.css';
import 'css/_common.scss';
import 'css/v2/_v2.scss';
import { useAppSelector } from 'careand-redux/store';
import { useAutoUpdateSafeAreas } from 'careand-redux/listeners/SafeAreaListener';
import useNativeEventsHandler from 'scenes/HomePatient2/NativeEventsHandler';
import { PostHogProvider } from 'posthog-js/react';
import config from 'config';
import GenericApp from './GenericApp';
import { useWaitForWarmup } from '../../careand-redux/listeners/UseWaitForWarmup';

const App = () => {
  const oldVersion = useAppSelector((state) => state.ui.oldVersion);
  const userRole = useAppSelector((state) => state.authentication.role);
  const isPatient = userRole === 'patient';

  useNativeEventsHandler(isPatient);
  useAutoUpdateSafeAreas();
  useWaitForWarmup();

  return (
    <React.Suspense fallback={null}>
      {oldVersion && !isPatient && <OldVersionScreen />}
      {!oldVersion && (
        <PostHogProvider
          apiKey={config.POSTHOG_KEY}
          options={{
            api_host: config.POSTHOG_HOST,
            autocapture: false,
          }}
        >
          <GenericApp />
        </PostHogProvider>
      )}
    </React.Suspense>
  );
};

App.propTypes = {
  authenticated: PropTypes.bool,
  environment: PropTypes.string,
  version: PropTypes.string,
};

export default DragDropContext(HTML5)(App);
